module.exports = "<div class=\"announcements\"\r\n     ng-if=\"!$ctrl.isLoading\">\r\n     <div class=\"announcements__header\">\r\n      <div class=\"announcements__subtitle\">\r\n        <translate>\r\n          Scheduled Announcements\r\n        </translate>\r\n      </div>\r\n    </div>\r\n    <announcement-list type=\"$ctrl.type\"\r\n                       announcements=\"$ctrl.scheduled\">\r\n    </announcement-list>\r\n</div>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/modules/dashboard/components/dashboard-widget/announcements/components/scheduled-announcements/scheduled-announcements.html
// module id = 1726
// module chunks = 0